import { VENDOR_CONFIG_TYPENAME } from "constants/vendor";
import { StackConfigVendor } from "types/generated";
import { getVendorName } from "utils/vendor";

export const isOutputReferenceAllowedByVendor = (vendor: StackConfigVendor["__typename"]) =>
  vendor !== VENDOR_CONFIG_TYPENAME.KUBERNETES && vendor !== VENDOR_CONFIG_TYPENAME.ANSIBLE;

export const getDisallowedVendorName = (vendor: StackConfigVendor["__typename"]) =>
  (vendor && getVendorName(vendor)) || "";
